// bao migrate skip
import TabPage from "./../../factories/tab-page";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import GenerictListTab from "./../../factories/generic-list-tab";

class HolidaySchemaVacationViewModel extends GenerictListTab {
    HolidaySchema: any;
    YearNumbers: KnockoutObservableArray<Number> = ko.observableArray([]);
    SelectedYear: KnockoutObservable<Number> = ko.observable(null);
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 430;
        this.HolidaySchema = parent;
        this.SelectedYear.subscribe(() => {
            if (this.PageIndex() != 0) {
                this.PageIndex(0);
            }
            this.Refresh();
        });
    }
    CustomFilter() {
        var customFilterHashObject = [];
        if (this.SelectedYear() != null) {
            var hashObjectYear: any = {};
            hashObjectYear.Key = 'Year';
            hashObjectYear.Value = this.SelectedYear();
            customFilterHashObject.push(hashObjectYear);
        }
        return customFilterHashObject;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
    loadFilter() {
        this.TabPage.IsLoading(true);
        return Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
            var DatumAkt = new Date();
            var JahrAkt = DatumAkt.getFullYear();
            for (var r in result) {
                if (result[r].Key != "" && result[r].Key != null)
                    this.YearNumbers.push(result[r].Key);
            }
            this.SelectedYear(JahrAkt);
            this.TabPage.IsLoading(false);
        });
    }
    ;
    loaded() {
        var def = $.Deferred();
        this.loadFilter().then(() => {
            this.Refresh().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
}
export default HolidaySchemaVacationViewModel;